module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"policy":"the privacy policy","read":"I have read"},"it":{"policy":"Privacy","read":"Ho letto l’informativa sulla"},"lt":{"policy":"Privatumo politika","read":"Perskaičiau"},"pl":{"policy":"polityka prywatności","read":"Przeczytałem/-am"}}')
  delete Component.options._Ctor
}
